export enum InviteStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  RE_INVITED = 'RE_INVITED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
}

export enum AuthorizedUserType {
  ACCOUNTANT = 'ACCOUNTANT',
  ADMIN = 'ADMIN',
}

export interface IAuthCustomer {
  customerId: string;
  customerFirstName: string;
  customerLastName: string;
  authorizedUserFullName: string;
  customerBusinessName: string;
  inviteStatus: InviteStatus;
  authorizedUserType: AuthorizedUserType;
  accessToken?: string;
  consentFormData?: string | Blob | null;
}

export interface IAuthOnboardingSlice {
  authOnboardingSlice: IAuthCustomer;
  setAuthOnboardingData: (data: IAuthCustomer) => void;
  getAuthUserType: () => AuthorizedUserType;
  getAuthUserAccessToken: () => string;
  setAuthUserAccessToken: (token: string) => void;
  setConsentFormData: (formData: string | Blob) => void;
  getConsentFormData: () => string | Blob | null;
}
